import React, { Component, forwardRef, lazy, Suspense, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader";

export default function lazyWithRetry(importer, { fallback = null, renderError }) {
  let Loaded = lazy(importer);

  class LoadBoundary extends Component {
    state = { failed: false };

    static getDerivedStateFromError() {
      return { failed: true };
    }

    componentDidCatch(error) {
      console.error("Ucitavanje nije uspjelo:", error);
    }

    retry = () => {
      this.props.onRetry();
      this.setState({ failed: false });
    };

    render() {
      return this.state.failed ? renderError(this.retry) : this.props.children;
    }
  }

  return forwardRef((props, ref) => {
    const [, setAttempt] = useState(0);
    const onRetry = () => {
      Loaded = lazy(importer);
      setAttempt((a) => a + 1);
    };

    return (
      <LoadBoundary onRetry={onRetry}>
        <Suspense fallback={fallback}>
          <Loaded ref={ref} {...props} />
        </Suspense>
      </LoadBoundary>
    );
  });
}

const centered = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  width: "100%",
  height: "100%",
};

export function lazyChart(importer) {
  return lazyWithRetry(importer, {
    fallback: (
      <div style={centered}>
        <ClipLoader color="#21538f" loading size={50} />
      </div>
    ),
    renderError: (retry) => (
      <div style={centered}>
        <span style={{ fontSize: 13, color: "#6b7280" }}>Prikaz nije učitan.</span>
        <button
          type="button"
          onClick={retry}
          style={{ border: "1px solid #21538f", background: "#fff", color: "#21538f", fontSize: 12, padding: "4px 12px", cursor: "pointer" }}
        >
          Pokušaj ponovo
        </button>
      </div>
    ),
  });
}
